import { Component, Input, OnInit } from '@angular/core';
import { SharedHandlerService } from '../../shared.handler.service';

@Component({
  selector: 'ngx-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Input() data: [];
  @Input() tittle: string;
  pageSize = 10;
  page = 1;
  totalData = 99999999;
  changingPage = false;
  dataPaginated = [];

  constructor(
    private readonly sharedHandlerService: SharedHandlerService,
  ) { }

  ngOnInit() {
    this.totalData = this.data.length;
    this.getDataPaginated();
  }

  setItemsPerPage(itemsPerPage: any): void {
    this.pageSize = itemsPerPage;
    this.changePageNew(1);
  }

  getPage(event) {
    this.page = event;
    this.changingPage = true;
    this.getDataPaginated();
  }

  changePageNew(event): void {
    this.page = event;
    this.getDataPaginated();
  }

  getDataPaginated() {
    this.dataPaginated = this.data.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    this.sharedHandlerService.applyPagination(this.dataPaginated);
  }
}
